import { render, staticRenderFns } from "./businessLogs.vue?vue&type=template&id=c47e9bfc&scoped=true"
import script from "./businessLogs.vue?vue&type=script&lang=js"
export * from "./businessLogs.vue?vue&type=script&lang=js"
import style0 from "./businessLogs.vue?vue&type=style&index=0&id=c47e9bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47e9bfc",
  null
  
)

export default component.exports